import { IntegrationRequirementsWebView } from '../view/IntegrationRequirementsWebView';
import { templateIntegrationRequirements } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { IntegrationRequirementsWebComponent } from '../component/IntegrationRequirementsWebComponent';

export class IntegrationRequirementsWebController extends BaseWebComponentController {
  public component: IntegrationRequirementsWebComponent;
  public view: IntegrationRequirementsWebView;
  public viewConstructor: typeof IntegrationRequirementsWebView;

  constructor(component: IntegrationRequirementsWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrationRequirementsWebView,
      viewTemplate: templateIntegrationRequirements,
    });
  }
}
